import { createContext, ReactNode, useContext, useReducer } from "react";
import { IGlobalState } from "../interfaces/states/IGlobalState";
import { IGlobalAction } from "../interfaces/states/IGlobalAction";
import { globalInitialState, globalReducer } from "./global-reducer";

interface GlobalContextType {
  state: IGlobalState;
  dispatch: React.Dispatch<IGlobalAction>;
}

const GlobalContext = createContext<GlobalContextType | undefined>(undefined);

export const GlobalProvider = ({ children }: { children: ReactNode }) => {
    const [state, dispatch] = useReducer(globalReducer, globalInitialState);

    return(
        <GlobalContext.Provider value={{ state, dispatch }}>
            {children}
        </GlobalContext.Provider>
    );
};

export const useGlobalContext = (): GlobalContextType => {
    const context = useContext(GlobalContext);

    if(!context) {
        throw new Error('useGlobalContext must be used within a GlobalProvider');
    }

    return context;
}